import React from 'react';
import ReactDOM from 'react-dom';
import Home from './components/Home';

import 'core-js';
import '@babel/polyfill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'custom-event-polyfill';

import '@livingsecurity/cyberblocks/dist/styles/app.css';
import '@livingsecurity/cyberblocks/dist/styles/fontawesome-all.min.css';

ReactDOM.render(<Home />, document.getElementById('root'));
